import React from 'react';
import { PremiumInfoDto } from 'types';
import { useTranslation } from 'utils/hooks';


import PlusInformation from './PlusInformation';
import css from './PlusTeaser.module.scss';

interface PlusTeaserProps 
{
  plusInhalte: PremiumInfoDto;
}

const PlusTeaser: React.FC<PlusTeaserProps> = (props) => 
{
  const { plusInhalte } = props;
  const { t, r } = useTranslation();

  const fakeContent = [
    (<div key='fakeContent1' className={css.fakeContent}>
      <span>{t('profiles:plusTeaser.fakeContent.heading1')}</span>
      <span>{r('profiles:plusTeaser.fakeContent.text1')}</span>
      <div className={css.overlay}/>
    </div>),

    (<div key='fakeContent2' className={css.fakeContent}>
      <span>{t('profiles:plusTeaser.fakeContent.heading2')}</span>
      <span>{r('profiles:plusTeaser.fakeContent.text2')}</span>
    </div>),
  ];

  return (
    <PlusInformation
      fakeContent={fakeContent}
      plusInhalte={plusInhalte}
    />
  );
};

export default PlusTeaser;
